import { render } from "./InvoiceRequestObligationView.vue?vue&type=template&id=2fd3cf22"
import script from "./InvoiceRequestObligationView.vue?vue&type=script&lang=js"
export * from "./InvoiceRequestObligationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/InvoiceRequestObligationView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fd3cf22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fd3cf22', __exports__)) {
    api.reload('2fd3cf22', __exports__)
  }
  
  module.hot.accept("./InvoiceRequestObligationView.vue?vue&type=template&id=2fd3cf22", () => {
    api.rerender('2fd3cf22', render)
  })

}


export default __exports__